import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@dgm/ui';
import { useAuth } from '../lib/auth.js';

/**
 * First-run onboarding wizard (Phase-2 A6). Shown by AppShell when an
 * authenticated user has not completed onboarding (FEATURES.onboarding +
 * /me.onboarded === false). A few opinionated steps; "Finish" / "Skip" marks
 * onboarding complete (POST /me/onboard) so it never shows again.
 */
const STEPS = [
  {
    title: 'Welcome to du-game-maker 👋',
    body: 'Build, deploy, and operate your own web games — all from one place. Let’s get you oriented in a few quick steps.',
  },
  {
    title: 'Your dashboard',
    body: 'The dashboard is your home base — it’ll track the games you create, publish, and their plays. Right now it’s an empty canvas.',
  },
  {
    title: 'Make it yours',
    body: 'Set your display name and preferences under Settings, and generate API keys for programmatic access when you’re ready. That’s it — happy building!',
  },
];

export function OnboardingWizard() {
  const completeOnboarding = useAuth((s) => s.completeOnboarding);
  const [step, setStep] = useState(0);
  const isLast = step === STEPS.length - 1;
  const current = STEPS[step]!;

  async function finish() {
    await completeOnboarding();
  }

  return (
    <Dialog open onOpenChange={(o) => !o && void finish()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{current.title}</DialogTitle>
          <DialogDescription>{current.body}</DialogDescription>
        </DialogHeader>
        <div className="mt-2 flex items-center justify-between">
          <div className="flex gap-1">
            {STEPS.map((_, i) => (
              <span
                key={i}
                className={`h-1.5 w-6 rounded-full ${i === step ? 'bg-primary' : 'bg-muted'}`}
              />
            ))}
          </div>
          <div className="flex gap-2">
            <Button variant="ghost" size="sm" onClick={finish}>
              Skip
            </Button>
            {isLast ? (
              <Button size="sm" onClick={finish}>
                Get started
              </Button>
            ) : (
              <Button size="sm" onClick={() => setStep((s) => s + 1)}>
                Next
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
